import authCss from '~/styles/auth.css';

import type { ExternalScriptsHandle } from 'remix-utils/external-scripts';

export { Layout as default } from './Layout';

export let handle: ExternalScriptsHandle = {
  scripts: [
  {
    src: '/scripts/gradient.js',
    preload: true
  }]

};

export function links() {
  return [
  {
    rel: 'stylesheet',
    href: authCss
  }];

}